<script>
    import { onMount } from 'svelte';
    import { Navigate, Route, navigateTo } from 'svelte-router-spa';
    import { auth } from "../../firebase/firebase.js";
    import PublicNavbar from '../../components/PublicNavbar.svelte';

    export let currentRoute;
    export let params;
    var loader = false;
    var email = '';

    var errorMessage = ''
    var successMessage = '';

    function validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function sendResetPasswordEmail() {
        successMessage = '';
        errorMessage = '';
        try {
            if (validateEmail(email)) {
                loader = true
                auth.sendPasswordResetEmail(email).then(() => {
                    successMessage = 'Sent password reset email'
                }).catch((error) => {
                    if (error && error['message']) {
                        errorMessage = error['message']
                    } else {
                        errorMessage = 'Something went wrong'
                    }
                }).finally(() => {
                    loader = false
                });

            } else {
                errorMessage = 'Invalid email'
            }
        } catch (error) {
            loader = false
            errorMessage = 'Something went wrong'
        }
    }

</script>

<PublicNavbar showLogin={true} showSupport={true} />
<div class="container-fluid" style="height: 100% !important;">
    <div class="row alignment">
        <div class="col-lg-4 col-md-4 col-sm-7 col-xs-12 forgot-password-form">
            <form id="register-form" role="form" autocomplete="off" class="form inner-form" onsubmit="return false">

                <div class="form-group text-center">
                    <i class="fa fa-lock fa-2x"></i>
                </div>
                <div class="form-group">
                    <input on:keyup.enter="{sendResetPasswordEmail}" bind:value={email} class="form-control" id="email"
                        aria-describedby="emailHelp" required data-error="Please enter a valid email."
                        placeholder="Email">
                </div>
                <div class="form-group">
                    {#if !loader}
                        <button on:click="{sendResetPasswordEmail}" class="btn btn-outline-primary btn-block">
                            Reset Password
                        </button>
                    {:else}
                        <button class="btn btn-outline-primary btn-block" disabled> <i class="fa fa-circle-o-notch fa-spin"></i> Loading </button>
                    {/if}
                </div>
                <div class="form-group text-center py-2">
                    <a class="btn-block" href="/login" role="button">Login</a>
                </div>
                {#if errorMessage}
                    <div style="position: absolute; min-width: 232px; max-width: 232px; line-height: 20px;" class="py-4 alert alert-danger" role="alert">
                        <strong>Alert!</strong> {errorMessage}
                    </div>
                {/if}
                {#if successMessage}
                    <div style="position: absolute; min-width: 232px; max-width: 232px; line-height: 20px;" class="py-4 alert alert-success" role="alert">
                        <strong>Success!</strong> {successMessage}
                    </div>
                {/if}
            </form>
        </div>
    </div>
</div>
<style>
    .alignment {
        display: flex;
        justify-content: center !important;
        align-items: center !important;
        height: 100%;
    }

    .forgot-password-form {
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
    }

    .inner-form {
        padding: 50px 20px 50px 20px;
        overflow-y: auto;
        max-height: 100%;
    }

    .forgot-password-background {
        height: calc(100vh);
        background: url('signin-background.png');
        background-position: center center;
        background-repeat: no-repeat;
    }

    @media (max-width: 575.98px) {
        .forgot-password-background {
            display: none;
        }
    }

    @media (max-width: 767.98px) {}
</style>